ad<template>
<div class="vrWrap">
   <!-- 加载条 {{loadProgress}}begin-->
   <div class="vrloading loadingTopbox wrap " v-show="!isLoadOk">
        <img src="../assets/svg/circles.svg" width="50" >
        <p style="margin-top: 0.12rem;">正在玩命加载资源...{{loadProgress}}%</p>
       <!-- <div class="loadingOutside">
          <div class="loadingOked"></div>
          <img src="../assets/svg/circles.svg" width="50" style="margin-top: -1.4rem;margin-left: 2rem;">
          <p>正在玩命加载资源...</p>
       </div> -->
   </div>
   <!-- 加载条 end-->

    <!-- 顶部菜单栏 -->
    <div class="outsidebox vrbox" :class="isLoadOk ? '' : 'noShowOpacity'" >
         <!-- 全景容器 -->
        <krpano></krpano>
         <!-- 全景容器 -->
        <!-- 游戏积分进度与规则 -->
         <gameProgress :getProgress="getProgress" @menuChecker="menuChecker" v-if="hasGame && !isPc && !isClearScreen"></gameProgress>
        <!-- 游戏积分进度与规则 -->
    </div>
    <!-- 顶部菜单栏 -->

     <!-- 热点图轮播 start-->
    <swiperImgs v-if="swiperImagesData.isShowSwiperImg" ref="swiperimgbox" @closeEventer="closeEventer" @siteEventSwiperImgIndex="siteEventSwiperImgIndex" :swiperImagesData="swiperImagesData" ></swiperImgs>
     <!-- 热点图轮播 end-->


    <!-- swiper轮播菜单 -->
  <!--   <menuSwipers  v-show="swiperState && !vrLookState" :menusListsData="menusListsData" :audioData="audioData" :isPc="isPc"  @clickMenuSwiper="clickMenuSwiper" ></menuSwipers> -->
    <!-- swiper轮播菜单 -->

    <!-- 全景缩略导航 -->
  <!--   <thumbLists :menuData="menuData" v-show="isShowThumbs"></thumbLists> -->
    <!-- 全景缩略导航 -->

    <!-- 外链Iframe -->
    <iframebox :iframeData="iframeData"></iframebox>
    <!-- 外链Iframe -->

     <!-- 底部功能菜单 start -->
     <!--   <menus v-show="isLoadOk && !isClearScreen" :vrLookState="vrLookState" @menuChecker="menuChecker"></menus> -->
     <!-- 底部功能菜单 end -->

     <videoBox v-show="videoData.isShow" :videoData="videoData" @clickCloseVideo="clickCloseVideo"></videoBox>

     <imageBox v-show="imagesData.isShow" :imagesData="imagesData" @clickCloseImages="clickCloseImages"></imageBox>

     <!-- 音频播放 muted-->
    <audio ref='audiobj' id="bjMusicEl" loop="loop" autoplay preload ></audio>
 <!--    <audio ref='audiosay' id="saySoundEl"  preload ></audio> -->
     <!-- 音频播放 :src="audioData.saySounds[audioData.audioIndex]" -->

    <!--  <loadingCj v-show="cjgamedata.loadingState"></loadingCj> -->

     <gamecjBox v-show="cjgamedata.isshow" ref="cjState"></gamecjBox>

     <div class="addCountsAnimate animated fadeInUp" v-show="touchEvetnData.ishowAnimate">{{addSorce}}</div>

     <!-- 抽奖 刮刮乐 -->
   <!--  <gamecj v-show="cjgamedata.isshow"  @bindgameClick="bindgameClick"></gamecj> -->
     <!-- 抽奖 刮刮乐 -->

     <!-- 抽奖 彩蛋 -->
   <!--  <gamecjEgg v-show="cjgamedata.isshow"  @bindgameClick="bindgameClick"></gamecjEgg>  -->
     <!-- 抽奖 彩蛋 -->
    <homevr v-show="isfirstInto"></homevr>

</div>
</template>

<script>
import wx from 'weixin-js-sdk';
import globalVar from '@/api/global_variable';
import thumbLists from '../components/thumbLists';
import iframebox from '../components/iframebox';
import swiperImgs from '../components/swiperImgs';
import gameProgress from '../components/gameProgress';
import krpano from '../components/krpano';
import videoBox from '../components/videoBox';
import imageBox from '../components/imageBox';
import homevr from '../components/Homevr';
import loadingCj from '../components/loadingCj';
import gamecjBox from '../components/gamecjBox';

    var wechats={
          　　　　title: '冷酸灵翻糖寻宝行动', // 分享标题
          　　　　desc: '参与互动游戏，让您收获惊喜礼包', // 分享描述
          　　　　link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          　　　　imgUrl: 'http://www.vweb365.com/h5/case/20200521dengkang_v7/static/img/share_icon.jpg', // 分享图标
    },
        shareDataF = {
            title: wechats.title,
            desc: wechats.desc,
            link: wechats.link,
            imgUrl: wechats.imgUrl,
            success: function() {
                alert("感谢您的分享！");
                /*vrComponents.fukuangData.gameSocre=0;
                vrComponents.getProgress=0;
                $(".gameProgressNow").css("width","0%");*/
                if(vrComponents.fukuangData.needReplay){
                  //window.location.reload();
                   vrComponents.setReplayData();
                }
            },
        },
        shareDataT = {
            title: wechats.title,
            link: wechats.link,
            imgUrl: wechats.imgUrl,
            success: function() {
                alert("感谢您的分享！");
                if(vrComponents.fukuangData.needReplay){
                  //window.location.reload();
                  vrComponents.setReplayData();
                }
            },
            error:function(e){
              console.log(e);
            }
        };
        function WechatConfig() {
            this.debug = false;
            this.appId = "wxccd29c5d7de65996";
            this.timestamp = "1583226285";
            this.nonceStr = "BLsjkrAbzDd07XbJ";
            this.signature = "3861efb63e0e6094b5645b3dc66c8190e8b0b90e";
            this.jsApiList = ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo"]
        }
        var wechatClient = null;

        function wxShare() {
            wx.ready(function() {
                // wx.updateAppMessageShareData(shareDataT);
                // wx.updateAppMessageShareData(shareDataT);
                wx.onMenuShareAppMessage(shareDataF);
                wx.onMenuShareTimeline(shareDataT);
                wx.onMenuShareQQ(shareDataF);
            });
            wx.error(function(a) {
              console.log(a);
            })
        }
        function wxShareConfig() {
           /* var sd_wx_url = "http://www.vweb365.com/php/wx/sample.php";*/
            var sd_wx_url = window.location.href;
            $.get(sd_wx_url, {
                url:window.location.href.split("#")[0]
            }, function(a) {
                wechatClient.debug = false;
                wechatClient.appId = a["appId"];
                wechatClient.jsApiList = ['updateAppMessageShareData',"updateTimelineShareData","onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo"];
                wechatClient.nonceStr = a["nonceStr"];
                wechatClient.signature = a["signature"];
                wechatClient.timestamp = a["timestamp"];
                wx.config(wechatClient);
                //console.log('config ok');
                wxShare()
            }, "json")
        }
        $(function() {
            wechatClient = new WechatConfig();
            wxShareConfig()
        }); 


export default {
  name: 'Vrbox',
  components: {
    thumbLists,iframebox,swiperImgs,gameProgress,krpano,videoBox,homevr,imageBox,loadingCj,gamecjBox
  },
  data () {
    return {
      addSorce:"+10%",
      touchEvetnData:{pageX:190,pageY:360,ishowAnimate:false},
      fukuangData:{
        luckState:false,//是否已抽奖
        needReplay:false,
        allSorce:100,
        gameSocre:0, 
        seeHotSportsIndex:'',
        seeHotSports:[],
        seeSenceLists:[],
        iconLists:['skin_hotspotstyle_couson_ya1','skin_hotspotstyle_couson_ya2','skin_hotspotstyle_couson_ya3','skin_hotspotstyle_couson_ya4','skin_hotspotstyle_couson_ya5','skin_hotspotstyle_couson_guobao6','skin_hotspotstyle_couson_guobao7','skin_hotspotstyle_couson_guobao8','skin_hotspotstyle_couson_guobao9','skin_hotspotstyle_couson_guobao10'],
        iconIndexNow:0,
        senceSportCounts:[
            {'senceName':'scene_1','setcounts':1,'getcounts':0},
            {'senceName':'scene_2','setcounts':1,'getcounts':0},
            {'senceName':'scene_3','setcounts':2,'getcounts':0},
            {'senceName':'scene_4','setcounts':1,'getcounts':0},
            {'senceName':'scene_5','setcounts':1,'getcounts':0},
            {'senceName':'scene_6','setcounts':1,'getcounts':0},
            {'senceName':'scene_7','setcounts':1,'getcounts':0},
            {'senceName':'scene_8','setcounts':1,'getcounts':0},
        ],
        rndSportArr:[
          [
            {'senceName':'scene_1','setcounts':2,'getcounts':0},
            {'senceName':'scene_2','setcounts':1,'getcounts':0},
            {'senceName':'scene_3','setcounts':1,'getcounts':0},
            {'senceName':'scene_4','setcounts':1,'getcounts':0},
            {'senceName':'scene_5','setcounts':1,'getcounts':0},
            {'senceName':'scene_6','setcounts':1,'getcounts':0},
            {'senceName':'scene_7','setcounts':1,'getcounts':0},
            {'senceName':'scene_8','setcounts':1,'getcounts':0},
          ],
          [
            {'senceName':'scene_1','setcounts':1,'getcounts':0},
            {'senceName':'scene_2','setcounts':1,'getcounts':0},
            {'senceName':'scene_3','setcounts':1,'getcounts':0},
            {'senceName':'scene_4','setcounts':1,'getcounts':0},
            {'senceName':'scene_5','setcounts':1,'getcounts':0},
            {'senceName':'scene_6','setcounts':2,'getcounts':0},
            {'senceName':'scene_7','setcounts':1,'getcounts':0},
            {'senceName':'scene_8','setcounts':1,'getcounts':0},
          ],
          [
            {'senceName':'scene_1','setcounts':1,'getcounts':0},
            {'senceName':'scene_2','setcounts':1,'getcounts':0},
            {'senceName':'scene_3','setcounts':2,'getcounts':0},
            {'senceName':'scene_4','setcounts':1,'getcounts':0},
            {'senceName':'scene_5','setcounts':1,'getcounts':0},
            {'senceName':'scene_6','setcounts':1,'getcounts':0},
            {'senceName':'scene_7','setcounts':2,'getcounts':0},
            {'senceName':'scene_8','setcounts':1,'getcounts':0},
          ]
        ]

      },
      isfirstInto:false,
      imagesData:{
        isShow:false,
        imagesIndex:'hotsport_1',
        data:{
           'hotsport_1':require('../assets/images/img_hotsprot1.jpg'),
           'hotsport_2':require('../assets/images/img_hotsprot2.jpg'),
           'hotsport_3':require('../assets/images/img_hotsprot3.jpg'),
           'hotsport_4':require('../assets/images/img_hotsprot4.jpg'),
        }
      },
      videoData:{
        isShow:false,
        videoIndex:'video_el0',
       /* data:{
           'video_el0':['',''],
           'video_el1':['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/1-1.mp4',require('../assets/images/video_textzi_1.png')],
           'video_el2':['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/2-1.mp4',require('../assets/images/video_textzi_2.png')],
           'video_el3':['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/3-1.mp4',require('../assets/images/video_textzi_3.png')],
           'video_el4':['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/4-1.mp4',require('../assets/images/video_textzi_4.png')],
           'video_el5':['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/5-1.mp4',require('../assets/images/video_textzi_5.png')],
           'video_el6':['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/6-1.mp4',require('../assets/images/video_textzi_6.png')],
        }*/
        data:{
           'video_el0':['',''],
           'video_el1':[require('../assets/video/1-1.mp4'),require('../assets/images/video_textzi_1.png')],
           'video_el2':[require('../assets/video/2-1.mp4'),require('../assets/images/video_textzi_2.png')],
           'video_el3':[require('../assets/video/3-1.mp4'),require('../assets/images/video_textzi_3.png')],
           'video_el4':[require('../assets/video/4-1.mp4'),require('../assets/images/video_textzi_4.png')],
           'video_el5':[require('../assets/video/5-1.mp4'),require('../assets/images/video_textzi_5.png')],
           'video_el6':[require('../assets/video/6-1.mp4'),require('../assets/images/video_textzi_6.png')],
        }
      },
      cjgamedata:{
        isshow:false
      },
      audioData:{
          isPlayBj:true,
          isPlaySay:false,
         /* bjMusic:'http://www.vweb365.com/h5/case/20200521dengkang/static/audio/music_bj.mp3',*/
           bjMusic:require('../../static/audio/music_bj_ok.mp3'),
          audioIndex:'sence1',
          saySounds:{
            sence1:'',
          },
          saySoundsPano:{
            sence1:'%SWFPATH%/static/mp3/zmrw.mp3',
          }
      },
  
      iframeData:{
        isshow:false,
        nowIndex:'share',
        state:'1',
        shareTitel:"参与冷酸灵翻糖寻宝行动互动游戏，让您收获惊喜礼包",
        shareUrl:window.location.href,
        sharePic:"http://www.vweb365.com/h5/case/20200521dengkang_v7/static/img/share_wb_img.jpg",
        sharesinastring:'',
        share:{url:'',name:'微博分享'},
      },
      swiperImagesData:{
        index:0,
        isShowSwiperImg:false,
        nowHotspot:'hotspot31',
        hotspot11:[require('../../static/img/picGrop1/1.jpg'),require('../../static/img/picGrop1/2.jpg'),require('../../static/img/picGrop1/3.jpg'),require('../../static/img/picGrop1/4.jpg'),require('../../static/img/picGrop1/5.jpg')],
        hotspot21:['../../static/img/picGrop1/1.jpg','../../static/img/picGrop1/2.jpg','../../static/img/picGrop1/3.jpg'],
        hotspot31:['../../static/img/picGrop1/1.jpg','../../static/img/picGrop1/2.jpg'],
      },
      krGyro:false,
      hasGame:true,
      isShowThumbs:false,
      isPc:false,
      isIos:false,
      isWxapp:false,
      firstTouch:0,
      isClearScreen:false,
      getProgress:0,
      loadProgress:0,
      isShowCodeImg:false,
      isLoadOk:false,
      gamePlayProgre:0,
      vrLookState:0,
      //0默认状态  1显示菜单
      swiperState:false,
      swiper:'',
    }
  },
  filters: {
      formatDate: function (value) {
        let date = new Date(value*1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
      formatDateFull: function (value) {
          let date = new Date(value*1000);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '年' + MM + '月' + d + '日 ' + h + ':' + m ;
      },
      totell:function(value){
        return "tell://"+value;
      },
      imgHandle:function(url){
       // console.log(globalVar);
        if(url){
          let urlstr=globalVar.imgHandle(url);
          return urlstr;
        }
      }
  },
  created(){
    this.isPc=globalVar.isPc();
    this.isIos=globalVar.isIos();
    this.isMinWxapp();
    this.defendCode();
    //生成产品icon随机方案
    this.setFukuangSenceSport();
  },
  mounted () {
    //getEnv获取环境
    let that=this;
    wx.miniProgram.getEnv(function (res) { 
      if (res.miniprogram) { 
          that.wxappOut();
      } 
    });
    this.initSwiperWrap();
   // this.share();
    //this.initAudioSay();
    this.initAudioBj();
    //设置微博分享URL
    this.iframeData.sharesinastring='http://v.t.sina.com.cn/share/share.php?title=' + encodeURIComponent(this.iframeData.shareTitel) + '&url=' + encodeURIComponent(this.iframeData.shareUrl) + '&content=utf-8&sourceUrl=' + encodeURIComponent(this.iframeData.shareUrl) + '&pic=' + encodeURIComponent(this.iframeData.sharePic);
    this.iframeData.share.url=this.iframeData.sharesinastring

    this.isTouchDevice();
    //预先加载指定图片
    this.preLoadingPic();
    window.vrComponents = this; 
  },
  destroyed(){
    window.vrComponents=null;
  },
  methods:{
      setFukuangSenceSport(){
        let rndNumIndex=this.randomNum(0,2);
        //console.log("随机icon方案"+rndNumIndex);
        this.fukuangData.senceSportCounts = this.fukuangData.rndSportArr[rndNumIndex];
      },
      defendCode(){
          document.onkeydown=function(){
              var e=window.event||arguments[0];
              if(e.keyCode==123){
                //  console.log("defend");
                  return false;
              }else if((e.ctrlKey)&&(e.shiftKey)&&(e.keyCode==73)){
                 // console.log("defend");
                  return false;
              }else if((e.ctrlKey)&&(e.keyCode==85)){//追加
  　　　　　　　　return false;
  　　　　　　　}
          };
          document.oncontextmenu=function(){
              //console.log("defend");
              return false;
          }
      },
      preLoadingPic(){
              //将其它页与背景图先提前动态加载出来--指定预加载
             /* let bjpicArr=[require("../assets/images/page1_bj.jpg"),require("../assets/images/page1_bj2.jpg"),require("../assets/images/img_hotsprot1.jpg"),require("../assets/images/img_hotsprot2.jpg"),require("../assets/images/img_hotsprot3.jpg"),require("../assets/images/img_hotsprot4.jpg"),require("../assets/images/page1_bj.jpg"),require("../assets/images/cj_jpno0.png")];*/
             let bjpicArr=['http://219.153.58.123:8080/car/fuyu_al/lengsuanling/page1_bj2.jpg',require("../assets/images/page1_bj.jpg"),require("../assets/images/img_hotsprot1.jpg"),require("../assets/images/img_hotsprot2.jpg"),require("../assets/images/img_hotsprot3.jpg"),require("../assets/images/img_hotsprot4.jpg"),require("../assets/images/page1_bj.jpg"),require("../assets/images/cj_jpno0.png")];
                  let imglen=bjpicArr.length;
                  let images = new Array();
                  for (let i = 0; i<imglen; i++) {
                      images[i] = new Image();
                      images[i].src=bjpicArr[i];
                  }
      },
      loadingImages(press){
              //加载图片
              let totalNum = 0;
              let jiazai = 0;
              let imgs = document.getElementsByTagName("img");

       
              //将指定图片添加到数组中
              let imgLen = imgs.length;  
              let that_=this;      
              for(let i = 0; i < imgLen; i++){
                  if(imgs[i].complete){
                      jiazai++;
                      let baifenbi = Math.floor(jiazai/imgLen*100);
                      //console.log(baifenbi);
                      that_.setPageLoading(baifenbi,'img');
                      continue;
                  }
                  imgs[i].onload = function(){
                      jiazai++;
                      let baifenbi = Math.floor(jiazai/imgLen*100);
                      //console.log(baifenbi);
                      that_.setPageLoading(baifenbi,'img');
                  }
              }
      },
      isTouchDevice(){
        //判断是否支持touch
        let that=this;
        try {
            document.createEvent("TouchEvent");
            //console.log("支持TouchEvent事件！");
            that.bindEvent(); //绑定事件
        } catch (e) {
            //console.log("不支持TouchEvent事件！" + e.message);
        }
      },
      bindEvent(){
        //绑定事件
        document.addEventListener('touchmove', function(event) {
            event.preventDefault();
        }, false);
        let that=this;
         document.addEventListener('touchend', function(evt){
              try {
                  //console.log(evt.changedTouches);
                  let touchData=evt.changedTouches;
                  let touchClientX=190,touchClientY=360;
                  if(touchData.length>0){
                    touchClientX=touchData[0].pageX;
                    touchClientY=touchData[0].pageY;
                  }
                  //console.log('X:'+touchClientX+'  Y:'+touchClientY);
                  that.touchEvetnData.pageX=touchClientX;
                  that.touchEvetnData.pageY=touchClientY;

              } catch (e) {
                  console.log('touchEndFunc：' + e.message);
              }
         }, false);
      },
      beginCj(){
        console.log('开始抽奖了');
      },
      showImageSport(hotsport){
        //保存已操作的热点
        let isFirstHit = setHotsportsData(hotsport);
        let that=this;
        //如果是第一次则调用动效-
        if(isFirstHit){
           that.addScoreHotsportsGame();
          setTimeout(function(){
              that.imagesData.imagesIndex=hotsport;
              that.imagesData.isShow=true;
          },1500);
        }else{
              that.imagesData.imagesIndex=hotsport;
              that.imagesData.isShow=true;
        }
      },
      addhotspot(iconName,senceName){
          //console.log("添加热点。。。");
          var krpano = document.getElementById("krpanoSWFObject");
          if (krpano)
          {
            /*var h=rnd(-80,140),v=rnd(-50,160);*/
            var h=rnd(-80,140),v=rnd(-20,10);
            var hs_name = "hs" + ((Date.now() + Math.random()) | 0);  
            krpano.call("addhotspot(" + hs_name + ")");
            krpano.call('setHotsport_style('+hs_name+','+iconName+')');
            krpano.set("hotspot["+hs_name+"].ath", h);
            krpano.set("hotspot["+hs_name+"].atv", v);
            krpano.set("hotspot["+hs_name+"].scale", 0.75);
            krpano.set("hotspot["+hs_name+"].distorted", true);
            if ( krpano.get("device.html5") )
            {
              krpano.set("hotspot["+hs_name+"].onclick", function(hs)
              {
                 checkGame(hs_name,senceName);
              }.bind(null, hs_name));
            }
            else
            {
              krpano.set("hotspot["+hs_name+"].onclick", "js( checkGame("+hs_name+","+senceName+") );");
            }
          }
      },
      isMinWxapp(){
          let ua = window.navigator.userAgent.toLowerCase();
          var flag = 1;
          if (ua.indexOf('micromessenger') == -1) {
              //console.log("不在微信或者小程序中")
              flag = 0;
          } else {
              wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                  console.log("在小程序中");
                  flag = 1;
                } else {//在微信中
                  console.log("在微信中")
                  flag = 2;
                }
              });
          }
          this.isWxapp=flag;
      },
      initSwiperWrap(){
        var swiper = new Swiper('.swiper-containerMenu', {
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            coverflowEffect: {
            rotate: 50,
            stretch: 10,
            depth: 100,
            modifier: 2,
            slideShadows : true,
            },
        });
        this.swiper=swiper;
      },
      initAudioBj(){
        this.$refs.audiobj.src = this.audioData.bjMusic;
        /*var krpano = document.getElementById("krpanoSWFObject");*/
        if(this.audioData.isPlayBj ){
          let el=document.getElementById('bjMusicEl');
          if(this.isIos){
            this.wxplayAudio(el);
            this.autoPlayAudioEvents(el);
          }
          document.getElementById('bjMusicEl').play();
          /* krpano.call("play_bjSound("+this.audioData.bjMusic+")");*/
        }else{
          document.getElementById('bjMusicEl').pause();
           /*krpano.call("pause_bjSound()");*/
           //console.log("zt...");
        }
      },
      autoPlayAudioEvents(el){
        //解决IOS不能自动播放的问题--只执行一次
        let that=this;
        document.addEventListener('touchstart', function(event) {
              if (that.firstTouch<2) { 
                  that.firstTouch ++ ; 
                   el.play();
                  // alert("firstTouch"+that.firstTouch);
              }else{
                  return; 
              } 
        }, false);
      },
      wxplayAudio(domEl){
         //监听微信初始化后播放音频
         document.addEventListener('DOMContentLoaded', function () {
              function audioAutoPlay() {
                      /*var el = document.getElementById('saySoundEl');*/
                      //domEl.play();
                  document.addEventListener("WeixinJSBridgeReady", function () {
                       //alert(domEl.id);
                      domEl.play();
                     // alert("WeixinJSBridgeReady");
                  }, false);
              }
              audioAutoPlay();
         });
      },
      initAudioSay(){
        this.$refs.audiosay.src = this.audioData.saySounds[this.audioData.audioIndex];
        let el=document.getElementById('saySoundEl');
        if(this.audioData.isPlaySay ){
          if(this.isIos){
            this.wxplayAudio(el);
            this.autoPlayAudioEvents(el);
          }
          document.getElementById('saySoundEl').play();
        }else{
          document.getElementById('saySoundEl').pause();
        }
      },
      setAudioSay(senceId){
        //设置场景音频介绍
        this.audioData.isPlaySay=true;
        this.audioData.audioIndex=senceId;
        let that=this;
        setTimeout(function(){
          that.initAudioSay();
        },300);
      },
      closeEventer(){
         this.swiperImagesData.isShowSwiperImg=!this.swiperImagesData.isShowSwiperImg
      },
      siteEventSwiperImgIndex(index){
        //console.log("swiperIndex:"+index);
        this.swiperImagesData.index=index;
      },
      siteSwiperimgIdEvent(index){
        //修改轮播子组件INDEX
        if(this.swiperImagesData.isShowSwiperImg){
          this.$refs.swiperimgbox.callMethod(index);
        }
      },
      clickCloseVideo(){
        this.playVideo(false);
        this.videoData.isShow=!this.videoData.isShow;
        //调用添加游戏积分
        //this.addScoreHotsportsGame();
       
      },
      clickCloseImages(){
        this.imagesData.isShow=!this.imagesData.isShow;
        //调用游戏积分
        //this.addScoreHotsportsGame();
      },
      playVideo(flag){
        // this.audioData.isPlayBj=!this.audioData.isPlayBj;
         //this.audioData.isPlaySay=!this.audioData.isPlaySay;
        // this.initAudioBj();
        // this.initAudioSay();
         if(flag){
            this.audioData.isPlayBj=false;
            document.getElementById("video").play();
            document.getElementById('bjMusicEl').pause();
         }else{
          document.getElementById("video").pause();
          this.audioData.isPlayBj=true;
          document.getElementById('bjMusicEl').play();
         }
      },
      clickMenuSwiper(type,page,state){
        //菜单轮播组件点击事件之方法
        //
        if(type=="close"){
          this.checkMenu();
        }else if(type=='gotoMenu' && state==false){
          this.gotoMenu(page);
        }else if(type=='clearScreen'){
          this.isClearScreen=!this.isClearScreen;
        }else if(type=='cutMusic'){
          this.audioData.isPlayBj=!this.audioData.isPlayBj;
          this.initAudioBj();
        }else if(type=='cutSay'){
          if(this.audioData.audioIndex){
            this.audioData.isPlaySay=!this.audioData.isPlaySay;
            this.initAudioSay();
          }else{
            console.log('暂无场景介绍音频');
          }
        }else if(type=='iframe'){
          this.showIframe(page);
        }
      },
      menuChecker(type,isCutSwiper){
        if(type=='thumbs'){
            this.isShowThumbs=!this.isShowThumbs;
            this.swiperState=false;
        }else if(type=='closewss'){
          this.WSwxonClose();
        }else if(type=='mycjgame'){
         this.cjgamedata.isshow=true;
        }else if(type=='showRuler'){
         this.isfirstInto=true;
        }else if(type=='gotomap'){
          this.showIframe('map');
        }else if(isCutSwiper==true){
            this.checkMenu(type);
        }
      },
      share(){
          let shareDataObj={
          　　　　title: '冷酸灵寻宝行动', // 分享标题
          　　　　desc: '参与互动游戏，让您收获惊喜礼包', // 分享描述
          　　　　link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          　　　　imgUrl: 'http://www.vweb365.com/h5/case/20200521dengkang_v7/static/img/share_icon.jpg', // 分享图标
                  success: function(){          
                    console.log("调用分享接口成功");
           　　　 }
          };
         /* let shareDataObj={
          　　　　title: '冷酸灵寻宝行动', // 分享标题
          　　　　desc: '参与互动游戏，让您收获惊喜礼包', // 分享描述
          　　　　linkurl: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          　　　　img: 'http://www.vweb365.com/h5/case/20200521dengkang/static/img/share_icon.jpg'
          };*/
          this.Share.wx(shareDataObj);
      },
      showIframeEventer(){
      },
      showIframe(log){
        this.iframeData.nowIndex=log;
        this.iframeData.isshow=true;
      },
      gotoMenu(page){
        if(page=='home'){
          //this.$router.push({ path: '/Home'});
          this.isfirstInto=true;
        }else{
          this.swiper.slideTo(page,0);
        }
      },
     checkMenu(log){
            if(log=='tell'){
              this.swiperState=false;
              if(!this.isPc){
                window.location.href='tel://'+this.menusListsData.tellPhone;
                return false;
              }
            }
            if(log==undefined || this.swiperState==true){
              this.swiperState=false;
              return false;
            }
            this.swiperState=true;
            //每次都初始化SWIPER
            this.initSwiperWrap();
            if(log=='showSwiperIndex'){
              this.gotoMenu(0);
            }else if(log=='getRuler'){
              this.gotoMenu(4);
            }else if(log=='messages'){
              this.gotoMenu(1);
            }else if(log=='vrlooking'){
              this.gotoMenu(1);
            }else if(log=='tell'){
              if(this.isPc){
                this.gotoMenu(6);
              }
            }
           this.isShowThumbs=false;
     },
     checkOutVrLook(){
         this.vrLookState=0;
     },
     setPageLoading(progess,loadType){
           //console.log(this.loadProgress);
          if(this.loadProgress>=90 && loadType=='img'){
                this.loadProgress=100;
                $('.loadingOked').css("width","100%");
                let _that=this;
                setTimeout(function(){
                  if(!_that.isLoadOk){
                    _that.isfirstInto=true;
                  }
                  _that.isLoadOk=true;
                },300);
          }else{
               let nowProgess=parseInt(progess/2);
               if(loadType=='vr'){
                  $('.loadingOked').css("width",nowProgess+"%");
                  this.loadProgress=nowProgess;
               }else if(loadType=='img'){
                   this.loadProgress=(50+nowProgess);
                   $('.loadingOked').css("width",this.loadProgress+"%");
               }
          }
     },
     setLoadProgress(progess){
        //全景资源加载进度
        //console.log(progess);
        let progessNum=progess;
        this.setPageLoading(progessNum,'vr');
        if(progessNum>=100){
          this.loadingImages();
        }
        //console.log(progessNum);
        /*$('.loadingOked').css("width",progess+"%");
        this.loadProgress=progess;
        if(progess>=100){
          let _that=this;
          setTimeout(function(){
            if(!_that.isLoadOk){
              _that.isfirstInto=true;
            }
            _that.isLoadOk=true;
          },300);
        }*/
     },
     bindgameClick(){
      this.cjgamedata.isshow=false;
     },
     setReplayData(){
      //重新开始时数据重置
      this.fukuangData.gameSocre=0;
      $('.gameProgressNow').animate({"width" :"0%"},'slow','swing');
      this.fukuangData.seeSenceLists=[];
      this.fukuangData.seeHotSports=[];
      this.getProgress=0;  
      this.iframeData.isshow=false;
      this.iframeData.isshow=false;
      this.videoData.isShow=false;
      this.imagesData.isShow=false;
      this.cjgamedata.isshow=false;
      this.$refs.cjState.resets();
      this.playVideo(false);
       this.setFukuangSenceSport();
      var krpano = document.getElementById("krpanoSWFObject");
        krpano.call("goto('scene_8','')");
     },
     setFukuang(secne){
      //判断与生成对应的福袋
      //判断是否完成收集任务
      if(this.fukuangData.gameSocre<this.fukuangData.allSorce){
        //判断是否当前场景已操作
        if(this.fukuangData.seeSenceLists.includes(secne)){
          //已操作
          return false;
        }else{
          //需要krpano 场景按此规则命名 
          let scene_index=secne.split("_")[1];
          let senceSportCounts=this.fukuangData.senceSportCounts[scene_index-1];
          let senceSportCountsNow=senceSportCounts.setcounts-senceSportCounts.getcounts;
          for (let i = 0; i < senceSportCountsNow; i++) {
             let that=this;
              //生成随机ICON的index
              let iconCounts=that.fukuangData.iconLists.length-1;
              let iconIndex=that.randomNum(0,iconCounts);
              let iconName=that.fukuangData.iconLists[iconIndex];
              vrComponents.fukuangData.iconIndexNow=iconIndex;
             //特别注意一下，只有当每场景只生成一个ICON的情况下，才能去做iconLists数组元素删除操作；
              //that.fukuangData.iconLists.splice(iconIndex,1); 
              //console.log("随机icon的index"+iconName);
              setTimeout(function(){
                 that.addhotspot(iconName,secne);
              },i*200);
          }
        }
      }
     },
     randomNum(min,max){
       return min + Math.floor(Math.random() * (max - min + 1));
     },
     addScoreHotsportsGame(){
      //点击热点后的显示效果
      if(this.fukuangData.seeHotSportsIndex!=''){
        //首次点击的热点
        this.fukuangData.gameSocre+=0.5;
        this.addSorce="+5%";
        this.gameProgress("hotspots");
        document.getElementById("biSound").play();
      }
     },
     gameProgress(type){
        if(type!='hotspots'){
          this.addSorce="+10%";
        }
        var press=this.fukuangData.gameSocre*10;
         let that=this;
        if(press>=100){
          press=100;
          if(this.fukuangData.luckState){
            //已抽过奖
            //console.log("已抽过奖");
            return false;
          }
          setTimeout(function(){
            that.cjgamedata.isshow=true;
          },1500);
        }
       
        setTimeout(function(){
         that.touchEvetnData.ishowAnimate=true;
          $('.addCountsAnimate').css({"top": that.touchEvetnData.pageY+"px","left": that.touchEvetnData.pageX+"px"  });
            setTimeout(function(){
                 $('.gameProgressNow').animate({"width" : press+"%"},'slow','swing');
                   that.touchEvetnData.ishowAnimate=false;
                 if(press<=99){
                          that.getProgress=press;
                        }else{
                          that.getProgress=100;
                }       
            },800);
        },300);
     }
  }
}
</script>

<style> 
    .wrap{ max-width: 100%!important; touch-action: none; }
    .outsidebox{position: relative;
    width: 7.5rem;
    margin: 0 auto; }
    .vrbox{ width: 100%; margin: 0 auto }
    
    .vrloading{ display: flex; justify-content: center; align-items: center; font-size: 0.28rem;  /* background: url(/static/img/page1_bj.6a85733.jpg); */ flex-direction:column;}
    div.vrloading::after{ content: "";background: url(../assets/images/page1_bj.jpg); opacity: 0.2; background-size: cover; top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;  }
.loadingOutside{width: 70%;
    height: 0.16rem;
    border-radius: 0.5rem;
    /* background-color: #fff;  */background-color: transparent;}
.loadingOutside  p{    text-align: center;
    padding-top: 0.1rem;}
.loadingOked {    width: 0%;
    height: 0.16rem;
    /* background-color: #098b8e; */
    background-color: transparent;
    border-radius: 0.5rem;}
.hide{display: none}
    .addCountsAnimate{    font-size: 0.42rem;
    position: absolute;
    top: 360px;width: 1.5rem;
    height: 1.5rem;
    left: 190px;
    z-index: 9999999;
    color: #ffdcb2;
    animation-duration: 1.5s;-webkit-animation-duration: 1.5s;  animation-delay:0s;-webkit-animation-delay:0s;
    font-weight: bold;}

  @media screen and (max-width: 450px) {
    .wrap{ max-width: 100%!important; }
  } 
</style>



// WEBPACK FOOTER //
// src/pages/Vrbox.vue